import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  overflow: auto;
`;

export const ListContainer = styled.div`
  container-name: life-area-list;
  container-type: inline-size;
`;

export const StaticRows = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `0 ${theme.spacing(4)} 0 ${theme.spacing(1)}`};
`;

export const PremiumBannerContainer = styled.div`
  padding: ${({ theme }) => `0 0 0 ${theme.spacing(3)}`};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: 0;
    `};
`;
